import { render } from "./FalmouthLetter.vue?vue&type=template&id=0be0ac17"
import script from "./FalmouthLetter.vue?vue&type=script&lang=js"
export * from "./FalmouthLetter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__